/**
 * Bounces the browser to an external URL (e.g. draftedge.com) on mount.
 *
 * Used as the route element for paths fantasy no longer owns — signup,
 * pricing/upgrade, password reset — so every in-app `<Link to="/register">`,
 * `to="/pricing">`, etc. funnels out to draftedge.com without touching each
 * call site.
 */
import { useEffect } from 'react';

export function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <div className="flex min-h-[40vh] items-center justify-center text-ink-muted">
      Redirecting to draftedge.com…
    </div>
  );
}
